export default __webpack_public_path__ + "static/media/btn-usplist-down.680eaacd.svg";